import { FocusEventHandler, ReactElement, ReactNode } from 'react'
import { Listbox } from '@headlessui/react'
import styles from './Select.module.css'
import iconCheck from '~public/images/icon-check.svg'
import iconDown from '~public/images/icon-down.svg'

type Option<T> = {
  value: T
  content: ReactNode
  key: string
}

type Props<T> = {
  options: Option<T>[]
  value: T
  setValue: (value: T) => void
  onFocus?: FocusEventHandler
  label: string
}

// eslint-disable-next-line @typescript-eslint/no-unnecessary-type-constraint -- The type constraint is necessary so JSX doesn't interpret the `<T>`.
export const Select = <T extends unknown>(props: Props<T>): ReactElement => {
  const { options, value, setValue, onFocus, label } = props

  const renderOption = (option: Option<T>) => (
    <Listbox.Option value={option.value} key={option.key}>
      <span>
        {option.value === value ? (
          <img src={iconCheck.src} alt="" />
        ) : (
          <>&nbsp;</>
        )}
      </span>
      {option.content}
    </Listbox.Option>
  )

  return (
    <Listbox
      as="div"
      onChange={setValue}
      onFocus={onFocus}
      className={styles.wrapper}
    >
      <Listbox.Button className={`button ${styles.button}`}>
        <span>{label}</span>
        <img src={iconDown.src} alt="" className={styles.chevron} />
      </Listbox.Button>
      <Listbox.Options className={styles.menu}>
        {options.map((option) => renderOption(option))}
      </Listbox.Options>
    </Listbox>
  )
}
